import React, { Fragment, Component } from 'react';
import { Item, Header } from 'semantic-ui-react';
import 'moment-duration-format';
import Flight from './Flight';
import AddDelayedFlight from './AddDelayedFlight';
import AddTicketDisruption from './AddTicketDisruption';
import { TicketFlightLabels, ClaimFlightLabels } from './FlightLabels';
import TicketFlightActionButtons from './TicketFlightActionButtons';

const FlightViewContainer = props => (
  <Item>
    <Item.Content>
      <Header>Trip Information</Header>
      {props.children}
    </Item.Content>
  </Item>
);

export class TicketFlightView extends Component {
  initialState = {
    delayedFlightFormIndex: undefined,
    delayedFlightTicketFormIndex: undefined
  };

  state = this.initialState;

  onDelayedFlightCreated = () => {
    this.setState({ delayedFlightFormIndex: undefined });
  };

  onDelayedFlightTicketCreated = () => {
    this.setState({ delayedFlightTicketFormIndex: undefined });
  };

  setEditFlight = id =>
    this.setState({
      delayedFlightFormIndex: id,
      delayedFlightTicketFormIndex: undefined
    });

  setEditTicket = id =>
    this.setState({
      delayedFlightFormIndex: undefined,
      delayedFlightTicketFormIndex: id
    });

  cancelEdit = () => this.setState(this.initialState);

  render() {
    return (
      <FlightViewContainer>
        {this.props.flights &&
          this.props.flights.map(({ flight, status = undefined }) => {
            const flightPassengerTicketId = flight.id;
            return (
              flight && (
                <Fragment key={flight.id}>
                  <Flight
                    labels={TicketFlightLabels}
                    actionButtons={() => (
                      <TicketFlightActionButtons
                        flight={flight}
                        status={status}
                        setEditTicket={() => this.setEditTicket(flight.id)}
                        setEditFlight={() => this.setEditFlight(flight.id)}
                      />
                    )}
                    status={status}
                    flight={flight}
                    claimFlightId={this.props.claimFlightId}
                    handleRemoveFlight={this.props.handleRemoveFlight}
                  />
                  {this.state.delayedFlightFormIndex === flight.id && (
                    <AddDelayedFlight
                      onFlightCreated={this.onDelayedFlightCreated}
                      cancelEdit={this.cancelEdit}
                      passengerTicketId={this.props.passengerTicketId}
                      flight={flight}
                    />
                  )}
                  {this.state.delayedFlightTicketFormIndex === flight.id && (
                    <AddTicketDisruption
                      onFlightTicketCreated={this.onDelayedFlightTicketCreated}
                      flightPassengerTicketId={flightPassengerTicketId}
                      passengerTicketId={this.props.passengerTicketId}
                      cancelEdit={this.cancelEdit}
                      flight={flight}
                    />
                  )}
                </Fragment>
              )
            );
          })}
      </FlightViewContainer>
    );
  }
}

export const ClaimFlightView = props => {
  return (
    <FlightViewContainer>
      {props.flights &&
        props.flights.map(({ flight, status = undefined }) => {
          return (
            flight && (
              <Flight
                key={flight.id}
                labels={ClaimFlightLabels}
                status={status}
                flight={flight}
                claimFlightId={props.claimFlightId}
                handleRemoveFlight={props.handleRemoveFlight}
              />
            )
          );
        })}
    </FlightViewContainer>
  );
};



// WEBPACK FOOTER //
// ./src/component/FlightView/index.js